import { getTRAITName } from './TRAIT';
var TraitInfo = /** @class */ (function () {
    function TraitInfo(abc, kind, name) {
        this.abc = abc;
        this.kind = kind;
        this.name = name;
        this.metadata = null;
        this.holder = null;
    }
    TraitInfo.prototype.getMetadata = function () {
        if (!this.metadata) {
            return null;
        }
        if (this.metadata instanceof Uint32Array) {
            var metadata = new Array(this.metadata.length);
            for (var i = 0; i < this.metadata.length; i++) {
                metadata[i] = this.abc.getMetadataInfo(this.metadata[i]);
            }
            this.metadata = metadata;
        }
        return this.metadata;
    };
    TraitInfo.prototype.getName = function () {
        return this.name;
    };
    TraitInfo.prototype.resolve = function () {
        if (typeof this.name === 'number') {
            this.name = this.abc.getMultiname(this.name);
        }
    };
    TraitInfo.prototype.toString = function () {
        return getTRAITName(this.kind) + ' ' + this.name;
    };
    TraitInfo.prototype.toFlashlogString = function () {
        this.resolve();
        return this.getName().toFlashlogString();
    };
    TraitInfo.prototype.isConst = function () {
        return this.kind === 6 /* Const */;
    };
    TraitInfo.prototype.isSlot = function () {
        return this.kind === 0 /* Slot */;
    };
    TraitInfo.prototype.isMethod = function () {
        return this.kind === 1 /* Method */;
    };
    TraitInfo.prototype.isGetter = function () {
        return this.kind === 2 /* Getter */;
    };
    TraitInfo.prototype.isSetter = function () {
        return this.kind === 3 /* Setter */;
    };
    TraitInfo.prototype.isAccessor = function () {
        return this.kind === 2 /* Getter */ ||
            this.kind === 3 /* Setter */;
    };
    TraitInfo.prototype.isMethodOrAccessor = function () {
        return this.isAccessor() || this.kind === 1 /* Method */;
    };
    return TraitInfo;
}());
export { TraitInfo };
